/* eslint-disable react-hooks/exhaustive-deps */
import { fetchPhpEigth } from 'api';
import {
  ambienteAplicacion,
  urlEmisionPoliza,
  urlListarAsegurados,
} from 'constants/urls';
import useCustomLocation from 'hooks/useCustomLocation';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetStateAction,
  setCatalogoAction,
  setLoadingCatalogoAction,
  setLoadingEditarBeneficiariosAction,
  setShowFormAgregarAction,
} from 'redux/actions/emision/asegurados.actions';
import { mappRutasEmision } from 'utils/funciones';

const useAsegurados = () => {
  const { addWarningToast } = useCustomToast();

  const { idPoliza, codProducto } = useQueryParams();

  const router = useCustomRouter();

  const location = useCustomLocation();

  const dispatch = useDispatch();

  const state = useSelector((state) => state.EmisionAseguradosReducer);

  const filterSecciones = (formulario) => (agrupacion) => {
    if (agrupacion.disabled) {
      return false;
    }
    if (agrupacion.formulario && agrupacion.formulario !== formulario) {
      return false;
    }
    return true;
  };

  const mappSecciones = (validaciones) => (agrupacion) => ({
    ...agrupacion,
    campos: validaciones.filter(
      (validacion) => validacion.grupo === agrupacion.codigo,
    ),
  });

  const _fetchAsegurados = async () => {
    const Data = {
      ambiente: ambienteAplicacion,
      idPoliza,
      prodCodigo: codProducto,
    };
    const res = await fetchPhpEigth(urlListarAsegurados, Data);
    console.log('RES: ', res);

    if (res.transaccion && res?.data) {
      const { listar, cargaAsegurados, recuperar } = res.data;

      const parentescos = listar.parentezcos.filter((e) => !e.ingresado);

      const catalogoForm = cargaAsegurados.catalogo;
      const { objParentezcos } = catalogoForm;

      cargaAsegurados.catalogo = undefined;

      const secciones = catalogoForm?.agrupaciones
        ?.filter(filterSecciones('asegurados'))
        .map(mappSecciones(catalogoForm.validaciones));

      const validaciones = secciones
        .flatMap((seccion) => seccion.campos)
        .map((field) => ({ ...field, hide: true }));

      dispatch(
        setCatalogoAction({
          asegurados: listar.listadoPersonas,
          datosPersonasIngresadas: listar.datosPersonasIngresadas,
          parentescos: parentescos,
          listadoParentescos: listar.parentezcos,
          aseguradosPath: location.fullPathname,
          disabledBtnAgregar: parentescos.length === 0,
          catalogoForm: {
            ...cargaAsegurados,
            ...catalogoForm,
            tipoPersona: catalogoForm.tipoPersona
              .filter((e) => e.value === 'F')
              .map((e) => ({ label: e.label, value: e })),
            secciones: secciones,
            agrupaciones: undefined,
            asegurado: {
              tipoPersona: catalogoForm.tipoPersona.find((e) => e.value === 'F'),
            },
            validaciones,
          },
          catalogoBeneficiarios: {
            validaciones: objParentezcos.validaciones,
            parentescos: objParentezcos.catalogoParentezcosBeneficiarios,
            minBeneficiarios: 1,
            maxBeneficiarios: 4,
            porcentajeMaximo: 100,
            min: 1,
            max: 4,
          },
          rutas: mappRutasEmision(
            recuperar.pasosRedireccionamiento,
            `&codProducto=${codProducto}`,
          ),
          msgError: listar.msgError,
        }),
      );
    } else {
      addWarningToast('Ha ocurrido un problema al consultar la información');
    }
  };

  const fetchAsegurados = useCallback(async () => {
    dispatch(setLoadingCatalogoAction(true));
    try {
      if (idPoliza && codProducto) {
        await _fetchAsegurados();
      } else {
        addWarningToast(
          'No tenemos la información necesaria para realizar este proceso',
        );
      }
    } catch (error) {
      console.log(error);
      addWarningToast('Ha ocurrido un problema al consultar la información');
    }
    dispatch(setLoadingCatalogoAction(false));
  }, []);

  const eliminarAsegurado = async (idAsegurado) => {
    dispatch(setLoadingCatalogoAction(true));
    const Data = {
      datosCotizador: {
        prodCodigo: codProducto,
        cotPasoCodigo: 'asegurado',
        polCodigo: idPoliza,
        accion: 'eliminar',
        idAsegurado,
        datosContratanteAsegurado: { prueba: 'asdfasd' },
      },
    };

    await fetchPhpEigth(urlEmisionPoliza, Data);

    await _fetchAsegurados();
    dispatch(setLoadingCatalogoAction(false));
  };

  const getParentesco = (parentesco) => {
    return state.parentescos.find((item) => item.value === parentesco);
  };

  const setShowFormAdd = (show, parentesco) => {
    window.scrollTo(0, 0);
    const url = `/emision-asegurados?idPoliza=${idPoliza}&codProducto=${codProducto}`;
    if (state) {
      router.replace(`${url}&parentesco=${parentesco}`);
    } else {
      router.replace(url);
    }
    dispatch(
      setShowFormAgregarAction({
        isShowFormAdd: show,
        parentescoFormAdd: show && getParentesco(parentesco),
      }),
    );
  };

  const resetState = (initialState = {}) => {
    dispatch(resetStateAction(initialState));
  };

  const _guardarInformacion = async (data, guardarDatos = true) => {
    try {
      data.parentezcoLabel = state.listadoParentescos.find(
        (item) => item.value === data?.parentezco,
      )?.label;
    } catch (error) {}
    const Data = {
      guardarDatos,
      datosCotizador: {
        prodCodigo: codProducto,
        cotPasoCodigo: 'asegurado',
        polCodigo: idPoliza,
        accion: data?.id ? 'modificar' : 'crear',
        idAsegurado: data?.id || '',
        datosContratanteAsegurado: data,
      },
    };
    try {
      data.beneficiarios = mappParentescosBeneficiarios(data?.beneficiarios || []);
    } catch (error) {}
    await fetchPhpEigth(urlEmisionPoliza, Data);
  };

  const guardarInformacion = async (data, guardarDatos = true) => {
    try {
      dispatch(setLoadingCatalogoAction(true));

      await _guardarInformacion(data, guardarDatos);
      await _fetchAsegurados();
      setShowFormAdd(false);
    } catch (error) {
      console.log(error);
      addWarningToast('Ha ocurrido un problema al guardar la información');
    }
    dispatch(setLoadingCatalogoAction(false));
  };

  const editarBeneficiarios = async (data) => {
    dispatch(setLoadingEditarBeneficiariosAction(true));
    try {
      await _guardarInformacion(data);
      await _fetchAsegurados();
    } catch (error) {
      console.log(error);
    }
    dispatch(setLoadingEditarBeneficiariosAction(false));
  };

  const getPorcentajes = (beneficiarios, porcentajeSuma = 0) => {
    let actual = 0;
    try {
      actual = beneficiarios
        ?.map?.((item) => +item?.porcentaje)
        ?.reduce?.((a, b) => a + b);
    } catch (error) {}
    return {
      actual,
      disponible: 100 - actual + porcentajeSuma,
    };
  };

  const guardarAsegurados = async () => {
    const { rutas, asegurados, datosPersonasIngresadas, msgError } = state;

    if (!rutas.contratante.completado) {
      return addWarningToast(
        <React.Fragment>
          <span>
            Para continuar es necesario completar la información del contratante
          </span>
          <br />

          <button className="link-mex" onClick={router.goTo(rutas.asegurado.goBack)}>
            Click aquí para ir a llenar la información
          </button>
        </React.Fragment>,
      );
    }

    const incompletos = asegurados.find(
      (item) => item.estadoIngreso === 'PENDIENTE',
    );

    if (incompletos) {
      return addWarningToast(
        'Por favor termine de llenar los formularios en estado PENDIENTE',
      );
    }

    const { finalizoIngresoAsegurados } = datosPersonasIngresadas;
    if (!finalizoIngresoAsegurados) {
      return msgError.forEach(addWarningToast);
    }

    const Data = {
      datosCotizador: {
        prodCodigo: codProducto,
        cotPasoCodigo: 'confirmarGuardarAsegurados',
        polCodigo: idPoliza,
      },
    };

    dispatch(setLoadingCatalogoAction(true));
    const res = await fetchPhpEigth(urlEmisionPoliza, Data);

    if (res.transaccion) {
      dispatch(setLoadingCatalogoAction(false));
      resetState();
      router.replace('/');
      return router.push(rutas.asegurado.goTo);
    }

    dispatch(setLoadingCatalogoAction(false));
    return addWarningToast('Ha ocurrido un problema al guardar la información');
  };

  const mappParentescosBeneficiarios = (beneficiarios = []) => {
    return beneficiarios?.map?.((beneficiario) => {
      beneficiario.parentescoLabel =
        state?.catalogoBeneficiarios?.parentescos?.find?.(
          (parentesco) => parentesco.value === beneficiario.parentesco,
        )?.label;
      beneficiario.porcentaje = Number(beneficiario?.porcentaje || 0);
      return beneficiario;
    });
  };

  return {
    ...state,
    fetchAsegurados,
    eliminarAsegurado,
    setShowFormAdd,
    resetState,
    getParentesco,
    guardarInformacion,
    editarBeneficiarios,
    getPorcentajes,
    guardarAsegurados,
    mappParentescosBeneficiarios,
    idPoliza,
    codProducto,
  };
};

export default useAsegurados;
